/** 即時脈衝點：只放在「資料正在輪詢」的位置（總覽狀態帶）。
 *  busy 時換成警示色且不脈衝，旁邊的文字要寫明「更新中…」。
 *  純裝飾，一律 aria-hidden；狀態靠旁邊的文字傳達。 */
export function LiveDot({ busy = false, className }: { busy?: boolean; className?: string }) {
  const cls = ['live-dot', busy ? 'live-dot--busy' : '', className ?? ''].filter(Boolean).join(' ');
  return <span className={cls} aria-hidden="true" />;
}
